export const US_EXCHANGES = ["NYSE", "NASDAQ", "NYSE AMERICAN"];
export const isUSExchange = (ex) => US_EXCHANGES.includes((ex || "").toUpperCase());

export const fmtINR = (n, opts = {}) => {
  const { showSign = false, decimals = 2 } = opts;
  if (n === null || n === undefined || isNaN(n)) return "₹0.00";
  const abs = Math.abs(Number(n));
  const formatted = abs.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const sign = n < 0 ? "-" : showSign ? "+" : "";
  // \u2060 (word joiner) prevents the sign from wrapping onto its own line
  return `${sign}\u2060₹${formatted}`;
};

export const fmtUSD = (n, opts = {}) => {
  const { showSign = false, decimals = 2 } = opts;
  if (n === null || n === undefined || isNaN(n)) return "$0.00";
  const abs = Math.abs(Number(n));
  const formatted = abs.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  const sign = n < 0 ? "-" : showSign ? "+" : "";
  return `${sign}\u2060$${formatted}`;
};

export const fmtPct = (n, decimals = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "0.00%";
  const sign = n > 0 ? "+" : "";
  return `${sign}${Number(n).toFixed(decimals)}%`;
};

export const fmtQty = (n) => {
  if (n === null || n === undefined) return "0";
  const num = Number(n);
  return Number.isInteger(num) ? num.toString() : num.toFixed(4).replace(/\.?0+$/, "");
};

export const colorByValue = (n) => {
  const v = Number(n) || 0;
  if (v > 0) return "text-positive";
  if (v < 0) return "text-negative";
  return "";
};
